const ConsultantConstant = {
   VIEW_CONSULTANT_LIST: "View Consultant List",
   ENTER_YOUR_BIO:"Enter your bio",
   CANCEL:"Cancel",
   SAVE:"Save",
   CONSULTANT_DETAILS:"Consultant Details",
   VIEW_AND_DOWNLOAD_PAN:"View & Download PAN Certificate",
   VIEW_AND_DOWNLOAD_RERA:"View & Download RERA Certificate",
   VIEW_DOCUMENTS:"View Documents",
   CONSULTANT_ID:"Consultant Id",
   PRIMARY_CONTACT_DETAIL:"primary contact detail",
   EMAIL:"Email",
   PHONE_NUMBER:"Phone Number",
   RERA_ID:"RERA ID",
   CREATED_AT:"Created At",
   EXPERIENCE:"Experience",
   BIO:"Consultant Bio",
   STATUS:"Status"
};

export default ConsultantConstant;